import api from './api';

export const getAllStores = async () => {
    try{
        const response = await api.get('/stores');
        return response.data;
    }catch(error){
        console.error('Error getting stores', error);
        throw error;
    }
};

export const getStoreById = async (id) => {
    try{
        const response = await api.get(`/stores/${id}`);
        return response.data;
    }catch(error){
        console.error('Error getting stores', error);
        throw error;
    }
};

export const createStore = async (data) => {
    try{
        const response = await api.post('/stores', data);
        return response.data;
    }catch(error){
        console.error('Error creating store:', error);
        throw error;
    }
};

export const updateStore = async (id, data) => {
    try{
        const response = await api.put(`/stores/${id}`, data);
        return response.data;
    }catch (error){
        console.error('Error updating store;', error);
        throw error;
    }
};

export const deleteStore = async (id) =>{
    try{
        const response = await api.delete(`/stores/${id}`);
        return response.data;
    }catch (error){
        console.error('Error deleting store:', error);
        throw error;
    }
};